import { deleteSubmission, fetchSubmissionsForChallenge } from '@actions/submissions';
import {
    getSubmissionsDeleteError,
    getSubmissionsDeleteSuccess,
    getSubmissionsIsDeleting,
} from '@selectors/submissions';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

const useDeleteSubmission = (id: number): Hook => {
    const dispatch = useDispatch();
    const { challengeid } = useParams<{ challengeid: string }>();

    const isDeleting = useSelector(getSubmissionsIsDeleting);
    const deleteError = useSelector(getSubmissionsDeleteError);
    const deleteSuccess = useSelector(getSubmissionsDeleteSuccess);
    const prevSuccess = usePrevious(deleteSuccess);

    useEffect(() => {
        if (deleteSuccess && !prevSuccess) dispatch(fetchSubmissionsForChallenge(+challengeid));
    }, [dispatch, challengeid, deleteSuccess, prevSuccess]);

    const handleSubmit = () => {
        dispatch(deleteSubmission(id));
    };

    return {
        isDeleting,
        deleteError,
        handleSubmit,
        deleteSuccess,
        prevSuccess,
    };
};

interface Hook {
    isDeleting: boolean;
    prevSuccess: boolean;
    deleteSuccess: boolean;
    deleteError: string | null;
    handleSubmit: () => void;
}

export default useDeleteSubmission;
